



















import { EdexAuth } from '@adobe/edex/ui/shared/config/auth';
import { IMS } from '@adobe/edex/ui/shared/config/ims';
import { containsURL } from '@adobe/edex/ui/shared/utils';

// Only allow same-origin http(s) redirects. A URL-parser based allowlist catches
// scheme-injection tricks (mixed case, embedded whitespace, data: URIs, etc.) that
// the previous javascript|vbscript substring blocklist missed (VULN-38175).
function isSafeBackUrl(backUrl) {
  try {
    const resolved = new URL(backUrl, window.location.origin);
    return resolved.origin === window.location.origin && ['http:', 'https:'].includes(resolved.protocol);
  } catch (e) {
    return false;
  }
}
export default {
  created() {
    this.init();
  },

  methods: {
    async init() {
      // try to authenticate only if edex token is not present already AND logged in via ims
      if (await IMS.isAuthenticated()) {
        console.debug(`redirect back after auth`);
        const success = await this.$store.dispatch('member/authenticate');

        // if success - redirect back to the page where 'Sign In' has been clicked
        if (success) {
          let backUrl = this.$route.query.backUrl;
          // https://jira.corp.adobe.com/browse/VULN-26538, https://jira.corp.adobe.com/browse/VULN-38175
          backUrl = isSafeBackUrl(backUrl) ? backUrl : '';
          if (backUrl) {
            window.location.replace(backUrl);
            return;
          }
        } else {
          // TODO: Something went wrong - redirect to landing
        }
      }

      await this.$router.replace(
        this.rDecor({
          name: 'landing',
        })
      );
    },
  },
};
